import {
	ButtonType,
	EpicIcons,
	Icon,
	Tooltip,
	TooltipPosition,
} from "@constellation-academy/epic-ui";
import { useFormik } from "formik";
import React, { Suspense, useContext } from "react";
import { useLazyLoadQuery } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type reportsTableFilters_Query } from "@relay/reportsTableFilters_Query.graphql";
import { QUERY } from "./reports-table-filters.graphql";
import {
	wrapperClass,
	formContentWrapperClass,
	systemEmailWrapperClass,
} from "./reports-table-filters.styles";
import { type ReportsTableFiltersFormState } from "./reports-table-filters.types";
import { Button, ButtonVariant } from "../../../../components/button";
import { DefaultTextFieldComponent } from "../../../../components/DefaultTextInput";
import { ValidatedField } from "../../../../components/ValidatedField";
import { ReportsContext } from "../../reports.context";

export const ReportsTableFilters = () => {
	const { t } = useTranslation("common");
	const query = useLazyLoadQuery<reportsTableFilters_Query>(QUERY, {});
	const { filters, setFilters } = useContext(ReportsContext);

	const formik = useFormik<ReportsTableFiltersFormState>({
		initialValues: {
			...filters,
		},
		onSubmit: (values: ReportsTableFiltersFormState, { setSubmitting }) => {
			setFilters({ filterByReferenceNumberOpt: values.filterByReferenceNumberOpt });
			setSubmitting(false);
		},
	});

	const clearForm = () => {
		setFilters({});
		void formik.setFieldValue("filterByReferenceNumberOpt", "");
		formik.handleSubmit();
	};

	return (
		<Suspense fallback={t("app.loading")}>
			<div className={wrapperClass}>
				<form onSubmit={formik.handleSubmit}>
					<div className={formContentWrapperClass}>
						<ValidatedField<ReportsTableFiltersFormState, string>
							name="filterByReferenceNumberOpt"
							label={t("reports.referenceNumber")}
							className="mr-2"
							component={DefaultTextFieldComponent}
							formikConfig={formik}
						/>
						<Button
							type={ButtonType.Reset}
							variant={ButtonVariant.Outline}
							tooltip={t("user.resetFilter")}
							onClick={clearForm}
							icon={EpicIcons.TIMES}
						/>
						<Button
							type={ButtonType.Submit}
							tooltip={t("user.applyFilter")}
							icon={EpicIcons.SEARCH}
						/>
					</div>
				</form>

				<div className={systemEmailWrapperClass}>
					<Tooltip
						target="#report-system-email"
						position={TooltipPosition.Top}
						content={t("reports.systemEmailTooltip")}
					/>
					<div id="report-system-email">
						<Icon icon={EpicIcons.INFO_CIRCLE} />
					</div>
					<span>{t("reports.systemEmailLabel")}</span> {query.Viewer.Reports.SystemEmail}
				</div>
			</div>
		</Suspense>
	);
};
